const PROD_BACKEND = 'https://boldlyenglish.com/api';

const isLocalHost = (host) =>
  host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0';

/**
 * Single source of truth for the backend base URL (no trailing slash).
 *
 * Reads REACT_APP_APP_BASE_URL / REACT_APP_BACKEND_URL, but if that value
 * points at localhost while the app itself is being served from a real
 * domain, it is ignored and the production backend is used - so a stray
 * localhost value in an env file can never reach the live site again.
 */
export function getBackendBaseUrl() {
  const configured = (
    process.env.REACT_APP_APP_BASE_URL ||
    process.env.REACT_APP_BACKEND_URL ||
    ''
  )
    .trim()
    .replace(/\/+$/, '');

  if (!configured || configured.startsWith('/')) return PROD_BACKEND;

  const pointsToLocalBackend = /^https?:\/\/(localhost|127\.0\.0\.1|0\.0\.0\.0)(:\d+)?(\/|$)/i.test(
    configured
  );

  if (
    pointsToLocalBackend &&
    typeof window !== 'undefined' &&
    !isLocalHost(window.location.hostname)
  ) {
    return PROD_BACKEND;
  }

  return configured;
}
